export default __webpack_public_path__ + "static/media/p13.8e40901d.PNG";